<template>
  <v-container fluid>
    <v-flex>
      <v-row no-gutters class="permissions-error-root-wrapper">
        <v-col class="permissions-error-item-wrapper">
          <slot
            name="permissions-error-item"
            class="permissions-error-item-slot"
          />
        </v-col>
      </v-row>
    </v-flex>
  </v-container>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import './styles/permissions-error-layout.scss';

@Component
export default class PermissionsErrorLayout extends Vue {}
</script>
